<template>

  <div :style="{ backgroundImage: `url(${info_banner.mobile_image.webp}), url(${info_banner.mobile_image.source})`, backgroundSize: 'var(--info-block-desktop-background-size)' }"
       class="info-block info_banner--mobile">
    <div class="container-lg">
      <div class="row">
        <div class="col-lg-7">
          <h3 class="info-block__title">
            {{ in18['page_informative_block'] }}
          </h3>
          <div class="info-block__text">
            {{ in18['page_informative_block_description'] }}
          </div>
          <a :href="info_link" :title="in18['page_show_more']" class="btn  btn--red  btn--md">
            {{ in18['page_show_more'] }}
          </a>
        </div>
      </div>
    </div>
  </div>


  <div :style="{ backgroundImage: `url(${info_banner.desktop_image.webp}), url(${info_banner.desktop_image.source})`, backgroundSize: 'var(--info-block-desktop-background-size)'} "
       class="info-block info_banner--desktop">
    <div class="container-lg">
      <div class="row">
        <div class="col-lg-7">
          <h3 class="info-block__title">
            {{ in18['page_informative_block'] }}
          </h3>
          <div class="info-block__text">
            {{ in18['page_informative_block_description'] }}
          </div>
          <a :href="info_link" :title="in18['page_show_more']" class="btn btn--red btn--md">
            {{ in18['page_show_more'] }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:  "Info",
  props: [
    'in18',
    'info_banner',
    'info_link',
  ],
}
</script>